import { useStoryBibleStore } from "src/stores/storyBibleStore";
import { Character } from "../../../src/shared/types";
import { AI_VISIBILITY } from "../../../src/shared/enums";
import { extractTextFromTipTap } from "../../../src/shared/schemas/CharacterSchema";

export const useCharacterNames = (characterIds: string[] = []) => {
  const characters: Character[] = useStoryBibleStore((state) => state.charactersEntities) || [];
  return characterIds
    .map((id) => {
      const c = characters.find((character: Character) => character.id === id);
      // Match the POV picker: hidden characters must not reach either the
      // preflight summary or the generation request through saved selections.
      if (!c || !c.name || c.aiVisibility === AI_VISIBILITY.HIDDEN) return undefined;
      return extractTextFromTipTap(c.name);
    })
    .filter(Boolean);
};
